import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";

const initialState = {
  errors: null,
  isLoading: false,
  proposalData: [],
};

const ProposalSlice= createSlice({
    name:"proposal",
    initialState,
      reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setProposalData: (state, action) => {
      state.proposalData = action.payload;
    },
}
})


export const createProposal =(data)=>async(dispatch)=>{
    dispatch(setLoading(true));
    console.log(data,"data")
    try{
    let URL = "/proposal";
    const response = await axiosInstance.post(URL,data);
    console.log(response,"response")

    const { status, message } = response?.data || {};

    if (status === "success") {
      dispatch(setProposalData(response?.data?.data));
    } 

    }catch(error){
      const errorMsg =
      error?.response?.data?.message ||
      error.message ||
      "Something went wrong.";

    dispatch(setErrors({
      status: error?.response?.status,
      message: errorMsg,
    }));

    }
    
}


export const{setErrors, setLoading, setProposalData }= ProposalSlice.actions;

export default ProposalSlice.reducer